export const IMPORTED_PAYMENT_REVIEW = Object.freeze({
  pending: "Needs review",
  paid: "Confirmed paid",
  open: "Confirmed not paid",
});

export const isImportedPaymentPending = (invoice) => (
  invoice?.importedPaymentStatus === IMPORTED_PAYMENT_REVIEW.pending
);

export const invoiceSettlementDate = (invoice) => {
  if (invoice?.paidOn || invoice?.paidDate) return invoice.paidOn || invoice.paidDate;
  if (invoice?.importedPaymentStatus === IMPORTED_PAYMENT_REVIEW.paid) return invoice.issuedDate || invoice.issued || "";
  if (invoice?.importedPaymentStatus) return "";
  return invoice?.issuedDate || invoice?.issued || "";
};

export const normalizePrivateImportedPayments = (data) => {
  if (!data?.privateLocalWorkspace || !Array.isArray(data.invoices)) return data;

  let changed = false;
  const invoiceStatuses = { ...(data.invoiceStatuses || {}) };
  const invoices = data.invoices.map((invoice) => {
    if (!isImportedPaymentPending(invoice)) return invoice;
    const currentStatus = invoiceStatuses[invoice.id] || invoice.status;
    if (currentStatus === "Paid") return invoice;

    changed = true;
    invoiceStatuses[invoice.id] = "Paid";
    return {
      ...invoice,
      status: "Paid",
      paymentStatusSource: invoice.paymentStatusSource || "historical-import-assumption",
    };
  });

  return changed ? { ...data, invoices, invoiceStatuses } : data;
};

export const applyImportedPaymentDecision = ({ invoices = [], invoiceStatuses = {}, invoiceId, decision, reviewedAt }) => {
  const reviewStatus = decision === "paid"
    ? IMPORTED_PAYMENT_REVIEW.paid
    : IMPORTED_PAYMENT_REVIEW.open;
  const invoiceStatus = decision === "paid" ? "Paid" : "Sent";
  let reviewedInvoice = null;
  const nextInvoices = invoices.map((invoice) => {
    if (invoice.id !== invoiceId || !invoice.importedPaymentStatus) return invoice;
    reviewedInvoice = {
      ...invoice,
      importedPaymentStatus: reviewStatus,
      paymentStatusSource: "manual-import-review",
      paymentReviewedAt: reviewedAt || new Date().toISOString(),
    };
    return reviewedInvoice;
  });

  if (!reviewedInvoice) return { ok: false, invoices, invoiceStatuses };
  return {
    ok: true,
    invoice: { ...reviewedInvoice, status: invoiceStatus },
    invoices: nextInvoices,
    invoiceStatuses: { ...invoiceStatuses, [invoiceId]: invoiceStatus },
  };
};

export const importedPaymentReviewPeriod = (invoices = []) => invoices
  .filter(isImportedPaymentPending)
  .map((invoice) => String(invoice.issuedDate || invoice.issued || "").slice(0, 7))
  .filter(Boolean)
  .sort()
  .at(-1) || "";
